export default __webpack_public_path__ + "static/media/observatory.81d5dd91.svg";